import { Box } from '@chakra-ui/react';
// import { Avatar, AvatarImage, ListItemComp, ListItemCompLeading } from '@mesh.ai/rabbit';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';

import { USER_ROLES } from 'constants/ProjectConstants';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { TABLE_COLUMNS_DISPLAYNAME } from '../constants';
import { returnAdminAccessesString } from '../utils';

const CellContent = ({ columnName, cellData, columnKey }) => {
  const { enabledFeatures } = useSelector(selectLoggedInEmployeeData);

  const USER_ROLE_MAP = USER_ROLES({ enabledFeatures }).reduce(
    (prev, { value, label }) => ({ ...prev, [value]: label }),
    {}
  );

  switch (columnName) {
    case TABLE_COLUMNS_DISPLAYNAME.email: {
      const employeeEmail = cellData?.metadata?.email;
      // const employeeProfilePhoto = cellData?.profile?.profilePhoto;
      // const employeeFirstName = cellData?.displayName?.split(' ')[0] ?? '';
      return (
        <Box className="info" display="flex" flexDir="row" gap="12px">
          {/* <ListItemComp style={{ padding: 0 }}>
            <ListItemCompLeading>
              <Avatar>
                <AvatarImage src={employeeProfilePhoto} alt={`Profile picture of ${employeeFirstName}`} />
              </Avatar>
            </ListItemCompLeading>
          </ListItemComp> */}
          <TextBodyMedium>{employeeEmail || '-'}</TextBodyMedium>
        </Box>
      );
    }

    case TABLE_COLUMNS_DISPLAYNAME.employeeAccesses: {
      const { employeeAccesses } = cellData;
      const accessNames = returnAdminAccessesString(employeeAccesses, USER_ROLE_MAP);
      return (
        <Box>
          <TextBodyMedium wordBreak="break-word">{accessNames || '-'}</TextBodyMedium>
        </Box>
      );
    }

    default: {
      const value = cellData?.metadata?.[columnKey] ?? '';
      return (
        <Box className="info">
          <TextBodyMedium>{value || '-'}</TextBodyMedium>
        </Box>
      );
    }
  }
};

export default CellContent;
